import { render, staticRenderFns } from "./merchantCodeDialog.vue?vue&type=template&id=23822e99&scoped=true"
import script from "./merchantCodeDialog.vue?vue&type=script&lang=js"
export * from "./merchantCodeDialog.vue?vue&type=script&lang=js"
import style0 from "./merchantCodeDialog.vue?vue&type=style&index=0&id=23822e99&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23822e99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23822e99')) {
      api.createRecord('23822e99', component.options)
    } else {
      api.reload('23822e99', component.options)
    }
    module.hot.accept("./merchantCodeDialog.vue?vue&type=template&id=23822e99&scoped=true", function () {
      api.rerender('23822e99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/ozonPrint/components/merchantCodeDialog.vue"
export default component.exports